import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { Button } from "../../../ui/button"

import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "../../../ui/popover"
import { Toaster, toast } from 'sonner'
import ProTableOt from '../../../utility/componentOt/views/ProtableOt'
import { Row, Col } from '../../../ui/RowCol'
import { usePatronCategory } from '../../controllers/PatronCategoryController'
import { useProTableOt } from '../../../utility/componentOt/controllers/ProtableOtController'
import { useRef, useState } from 'react'
const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const PatronCategory = () => {
    const navigate = useNavigate()
    const actionRef = useRef()
    const columns = [
        {
            title: 'Code',
            dataIndex: 'categorycode',
            key: 'categorycode',
            sorter: true
        },

        {
            title: 'Category name',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Type',
            dataIndex: 'category_type',
            key: 'category_type',
            render: (text, record, index) => {
                let arr = [
                    {
                        "code": "A",
                        "name": "成人 (A)"
                    },
                    {
                        "code": "C",
                        "name": "兒童 (C)"
                    },
                    {
                        "code": "P",
                        "name": "專業人員 (P)"
                    },
                    {
                        "code": "I",
                        "name": "機構 (I)"
                    },
                    {
                        "code": "X",
                        "name": "統計 (X)"
                    },
                    {
                        "code": "S",
                        "name": "工作人員 (S)"
                    }
                ]

                let name = arr.find((ele) => ele.code === text)
                return (
                    <>{name.name}</>
                )
            }
        },

        {
            title: 'Enrollment period',
            dataIndex: 'enrolmentperiod',
            key: 'enrolmentperiod',
            render: (text, record, index) => {

                return (
                    <>{text || '-'}個月</>
                )
            }
        },
        {
            title: 'Password expiration',
            dataIndex: 'password_expiry_days',
            key: 'password_expiry_days',
            render: (text, record, index) => {

                return (
                    <>{text || '-'}天</>
                )
            }
        },
        {
            title: 'Age required',
            dataIndex: 'dateofbirthrequired',
            key: 'dateofbirthrequired',
            render: (text, record, index) => {

                return (
                    <>{text || '-'}歲</>
                )
            }
        },
        {
            title: 'Upper age limit',
            dataIndex: 'upperagelimit',
            key: 'upperagelimit',
            render: (text, record, index) => {

                return (
                    <>{text || '-'}歲</>
                )
            }
        },
        {
            title: 'Enrollment fee',
            dataIndex: 'enrolmentfee',
            key: 'enrolmentfee',
        },
        {
            title: 'Overdue',
            dataIndex: 'overduenoticerequired',
            key: 'overduenoticerequired',
            render: (text, record, index) => {
                return (
                    <>{text === 1 ? "是" : "否"}</>
                )
            }
        },
        {
            title: 'Lost items',
            dataIndex: 'hidelostitems',
            key: 'hidelostitems',
            render: (text, record, index) => {
                return (
                    <>{text === 1 ? "隱藏" : "顯示"}</>
                )
            }
        },
        {
            title: 'Hold fee',
            dataIndex: 'reservefee',
            key: 'reservefee',
        },
        {
            title: 'message(訊息)',
            dataIndex: 'message',
            key: 'message',
            width: "10rem",
            render: (text, record, index) => {
                return (
                    <Row>
                        {
                            text.filter((ele) => {
                                return ele?.email === 1
                            })
                                .map((value) => {
                                    return (
                                        <Col span={24}>
                                            <Row>
                                                <Col>
                                                    {value?.message_name}:
                                                </Col>
                                                <Col>
                                                    email
                                                </Col>
                                            </Row>
                                        </Col>
                                    )
                                })
                        }
                    </Row>
                )
            }
        },
        {
            title: 'Library limitations',
            dataIndex: 'branches',
            key: 'branches',
            render: (text, record, index) => {
                return (
                  <> {(text||[]).length} library limitation</>
                )
            }
        },
        {
            title: 'Default privacy',
            dataIndex: 'default_privacy',
            key: 'default_privacy',
        },
        {
            title: 'Exclude from local holds priority',
            dataIndex: 'exclude_from_local_holds_priority',
            key: 'exclude_from_local_holds_priority',
            render: (text, record, index) => {
                return (
                    <>{text === 1 ? "是" : "否"}</>
                )
            }
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            render: (text, record, index) => (
                <FlexBox>
                    <Button
                        onClick={() => {
                            navigate(`/library/backstage/PatronCategory/${record?.categorycode}`)
                        }}
                        variant="outline">
                        編輯
                    </Button>
                    <DeletePopHover
                        onConfirm={() => {
                            deletePatronCategoryData([
                                {
                                    categorycode: record?.categorycode
                                }
                            ])
                        }}
                    />
                </FlexBox>
            )
        },
    ]
    const {
        getPatronCategoryData,
        deletePatronCategoryData
    } = usePatronCategory({
        onFinish: ({ axiosMode, status, values }) => {
            if (axiosMode === "delete") {
                if (status === "success") {
                    toast.success('刪除成功');
                }
                else {
                    toast.error('刪除失敗')
                }
                actionRef.current.reload()
            }
        },
        onBefore: () => { }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })

    return (
        <Row>
            <Toaster
                richColors
                position="top-center"

            />
            <Col>
                <Title>讀者類型</Title>
            </Col>

            <Col span={24}>
                <ProTableOt
                    actionRef={actionRef}
                    columns={columns}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            // "categorycode": "TEST",
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        return getPatronCategoryData({
                            ...newParams
                        })
                    }}
                    rowSelection={false}

                    toolBarRender={() => {
                        return ([<Button variant="outline"
                            onClick={() => {
                                navigate('/library/backstage/PatronCategory/0')
                            }}>新增讀者類型</Button>
                        ])
                    }}
                />
            </Col>
        </Row>
    )
}
const DeletePopHover = ({
    onConfirm = () => { },
    onCancel = () => { }

}) => {
    const [deleteOpen, setDeleteOpen] = useState(false)

    return (
        <Popover
            open={deleteOpen}
        >
            <PopoverTrigger asChild>
                <Button onClick={() => {
                    setDeleteOpen(true)
                }} >
                    刪除
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-60">
                <Row>
                    <Col span={24}>
                        確定要刪除嗎？
                    </Col>
                    <Col span={24}>
                        <Row justify={'space-around'}>
                            <Col>
                                <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => {
                                        setDeleteOpen(false)
                                        onCancel()
                                    }}
                                >
                                    取消
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    size="sm"
                                    onClick={() => {
                                        onConfirm()
                                    }}
                                >
                                    確定
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </PopoverContent>
        </Popover>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: center;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const FlexBox = styled.div`
display: flex;
gap: 1em;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
}
`

export default PatronCategory